import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, number } from "yup";
import { resetStatus, setAdmin } from "../redux/usersSagas";
import { sendCode } from "../api";
import { useError } from "../hooks/useError";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "../../../../components/ErrorList";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { Input } from "../../../../components/form/Input/Input";
import { generatePassword } from "../../../../utils/password-utils";
import { showToast } from "../../../../utils/showToast";

const schema = object({
  verification_code: number()
    .label("Verification Code")
    .integer("Please enter numbers")
    .typeError("Please enter numbers")
    .required()
}).required();

const generatedPassword = generatePassword();

export const SetAdmin = ({ onClose, selected: { id, name, orgName } }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      send_welcome_email: true,
      password: generatedPassword,
      password_confirmation: generatedPassword
    }
  });

  const dispatch = useDispatch();

  const close = () => {
    dispatch(resetStatus());
    onClose();
  };

  const { errors: serverErrors, status } = useError(() => {
    showToast("User was set as admin");
    close();
  });

  useEffect(() => {
    sendCode();
  }, []);

  const onSubmit = async (data) => {
    dispatch(setAdmin({ data, id, orgName }));
  };

  const primaryButtonDisabled = isSubmitting || status == "pending";

  return (
    <>
      <MainModal
        isOpen
        onClose={close}
        parentSelector=".admin-users"
        headerText={`Set Admin - ${name}`}
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={handleSubmit(onSubmit)}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height="auto"
        width={900}
      >
        <div>
          <div className="admin-users__verification">
            <Input
              label="Enter Verification Code:"
              htmlFor="verification_code"
              customProps={register("verification_code")}
            />
            <button
              className="button button--secondary button--no-outline"
              onClick={() => sendCode("sms")}
            >
              Resend Verification Code (SMS)
            </button>
            <button
              className="button button--secondary button--no-outline"
              onClick={() => sendCode("email")}
            >
              Resend Verification Code (EMAIL)
            </button>
          </div>

          {status === "pending" && <LoadingAnimation uiLoader />}
          <ErrorList errors={{ ...errors, ...serverErrors }} />
        </div>
      </MainModal>
    </>
  );
};
